import { spacing } from "@conserveit/blocks";
import styled from "styled-components";

export const Wrapper = styled.div`
  padding-top: ${spacing.extraTight};
  border-top: 1px solid;
  border-color: #ddd;
`;

export const CommentActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${spacing.default};
`;
